import type { PropType } from 'vue';

export const NOTIFICATION_TYPES = ['success', 'error', 'warning', 'info'] as const;
export const NOTIFICATION_LAYOUTS = ['banner', 'inline'] as const;

export type NotificationType = typeof NOTIFICATION_TYPES[number];
export type NotificationLayout = typeof NOTIFICATION_LAYOUTS[number];

export default {
  type: {
    type: String as PropType<NotificationType>,
    validator: (value: string): boolean => (NOTIFICATION_TYPES as readonly string[]).includes(value),
    required: true as const,
  },
  layout: {
    type: String as PropType<NotificationLayout>,
    validator: (value: string): boolean => (NOTIFICATION_LAYOUTS as readonly string[]).includes(value),
    default: 'banner',
  },
  title: {
    type: String,
  },
  isDismissible: {
    type: Boolean,
    default: false,
  },
};
